import { Link } from "react-router-dom";

export default function PrivacyPolicy() {
  return (
    <div data-testid="privacy-page">
      <section className="border-b border-zinc-800 bg-zinc-950">
        <div className="container-pl py-20">
          <p className="overline mb-5">Legal</p>
          <h1 className="display-serif text-5xl lg:text-6xl text-zinc-50 leading-[1.05] mb-4">
            Privacy Policy
          </h1>
          <p className="text-sm text-zinc-400 font-mono tracking-wider">Last updated: February 2026</p>
        </div>
      </section>

      <section className="container-pl py-20 max-w-3xl">
        <div className="prose-content space-y-10 text-zinc-200 leading-relaxed">
          <div>
            <h2 className="display-serif text-2xl text-zinc-50 mb-3">Overview</h2>
            <p className="text-base">
              Paralegal Voices of New York ("we," "us," or "our") is committed to protecting the
              privacy of every individual who contacts us, schedules a consultation, or becomes a
              client. This policy explains what information we collect, how we use it, and the
              choices you have.
            </p>
          </div>

          <div>
            <h2 className="display-serif text-2xl text-zinc-50 mb-3">Information We Collect</h2>
            <p className="text-base mb-3">We collect only what is necessary to provide our services:</p>
            <ul className="list-disc pl-5 space-y-1.5 text-base text-zinc-300">
              <li>Contact information you provide (name, email, phone)</li>
              <li>Case details you share during intake or consultation</li>
              <li>Documents you submit for review or preparation</li>
              <li>Appointment history and case progress data</li>
              <li>Basic technical information (browser type, IP address) for site security</li>
            </ul>
          </div>

          <div>
            <h2 className="display-serif text-2xl text-zinc-50 mb-3">How We Use Information</h2>
            <ul className="list-disc pl-5 space-y-1.5 text-base text-zinc-300">
              <li>To prepare your documents and provide paralegal services</li>
              <li>To coordinate with reviewing attorneys on your behalf</li>
              <li>To communicate with you about appointments and case updates</li>
              <li>To maintain accurate records as required by professional standards</li>
            </ul>
          </div>

          <div>
            <h2 className="display-serif text-2xl text-zinc-50 mb-3">Confidentiality</h2>
            <p className="text-base">
              All information shared with Paralegal Voices of New York is treated as strictly
              confidential. Files in our secure vault are encrypted in transit and at rest, and
              access is restricted to authorized personnel only.
            </p>
          </div>

          <div>
            <h2 className="display-serif text-2xl text-zinc-50 mb-3">Sharing of Information</h2>
            <p className="text-base">
              We do not sell, rent, or share your personal information with third parties for
              marketing purposes. We may share information only:
            </p>
            <ul className="list-disc pl-5 space-y-1.5 mt-3 text-base text-zinc-300">
              <li>With the reviewing attorney involved in your case, at your direction</li>
              <li>With service providers that help us operate (e.g., secure file storage)</li>
              <li>If required by law, subpoena, or valid legal process</li>
            </ul>
          </div>

          <div>
            <h2 className="display-serif text-2xl text-zinc-50 mb-3">Your Rights</h2>
            <p className="text-base">
              You may request a copy of the information we hold about you, request corrections, or
              ask us to delete your data (subject to record-retention requirements). To exercise
              these rights, email{" "}
              <a href="mailto:Darrell@paralegalvoicesofnewyork.com" className="text-amber-400 link-underline">
                Darrell@paralegalvoicesofnewyork.com
              </a>
              .
            </p>
          </div>

          <div>
            <h2 className="display-serif text-2xl text-zinc-50 mb-3">Contact</h2>
            <p className="text-base">
              Questions about this policy? Reach out at{" "}
              <a href="mailto:Darrell@paralegalvoicesofnewyork.com" className="text-amber-400 link-underline">
                Darrell@paralegalvoicesofnewyork.com
              </a>
              .
            </p>
          </div>

          <div className="pt-8 border-t border-zinc-800">
            <Link to="/terms" className="text-sm text-amber-400 link-underline">
              View Terms of Service →
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
